/**
 * @desc 新增全局或基地设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.NewGlobalOrBaseParameterSetting,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/setting/detail/add',
    data,
  });
}

export function mock(
  data: defs.NewGlobalOrBaseParameterSetting,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/setting/detail/add',
    data,
  });
}
